import React from "react";
import Grass from "../../sections/Grass";
import Logo from "../../assets/sloth/smsc_logo.png";
import OpenSea from "../OpenSea";
import Link from "../../utils/link";

const Links = [
  { name: "Sanctuary", link: "/#sanctuary" },
  { name: "Roadmap", link: "/#roadmap" },
  { name: "Team", link: "/#team" },
  { name: "FAQs", link: "/#faqs" },
];

function UncommonLogo(props) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0.15 0.06 140 16.88"
      {...props}
    >
      <path
        d="M.146 10.607c0 4.098 2.007 6.333 6.435 6.333 4.451 0 6.458-2.235 6.458-6.333V.293h-1.892v10.012c0 3.329-1.176 5.005-4.566 5.005-3.39 0-4.543-1.676-4.543-5.005V.293H.146v10.314zM15.9.293h1.891v14.505l-.3 1.374h.531L26.117.292h3.805v16.415h-1.867V2.202l.3-1.374h-.531l-8.118 15.88H15.9V.292zM47.53 8.488c0 4.797-2.837 8.452-7.611 8.452-4.152 0-6.873-2.515-7.358-6.589h1.892c.369 3.143 2.283 4.96 5.465 4.96 3.783 0 5.72-2.841 5.72-6.823 0-3.958-1.937-6.798-5.72-6.798-3.182 0-5.096 1.793-5.465 4.936H32.56C33.046 2.575 35.767.06 39.92.06c4.774 0 7.61 3.655 7.61 8.428zM49.926 8.488c0 4.797 2.814 8.452 7.61 8.452 4.752 0 7.565-3.655 7.565-8.452 0-4.773-2.813-8.428-7.564-8.428-4.797 0-7.61 3.655-7.61 8.428zm1.891 0c0-3.911 1.868-6.798 5.72-6.798 3.828 0 5.673 2.887 5.673 6.798 0 3.935-1.845 6.822-5.673 6.822-3.852 0-5.72-2.887-5.72-6.822zM67.792 16.707h1.89V2.202L69.384.828h.53l4.66 15.88h3.805L83.035.827h.554l-.323 1.374v14.505h1.89V.293h-3.781L76.74 16.172h-.53L71.597.292h-3.805v16.415zM88.264 16.707h1.892V2.202l-.3-1.374h.53l4.659 15.88h3.805L103.51.827h.553l-.322 1.374v14.505h1.891V.293h-3.783l-4.635 15.879h-.53L92.07.292h-3.806v16.415zM108.259 8.488c0 4.797 2.813 8.452 7.61 8.452 4.751 0 7.565-3.655 7.565-8.452 0-4.773-2.814-8.428-7.565-8.428-4.797 0-7.61 3.655-7.61 8.428zm1.891 0c0-3.911 1.868-6.798 5.719-6.798 3.829 0 5.674 2.887 5.674 6.798 0 3.935-1.845 6.822-5.674 6.822-3.851 0-5.719-2.887-5.719-6.822zM126.124.293h1.891v14.505l-.299 1.374h.53l8.095-15.88h3.805v16.415h-1.868V2.202l.3-1.374h-.53l-8.118 15.88h-3.806V.292z"
        fill="#E6FFF1"
      />
    </svg>
  )
}

function Cheveron(props) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0.83 0.91 16.01 16"
      {...props}
    >
      <g clipPath="url(#clip0_1021_7861)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.23 13.773c.165.146.379.227.6.227.982.043 1.966-.027 2.933-.207.336-.047.653-.183.92-.393a.547.547 0 00.146-.48 5.091 5.091 0 00-.76-1.713 17.925 17.925 0 00-1.553-2.074c-.261-.294-.52-.59-.777-.886-.425-.488-.85-.976-1.29-1.454-.477-.52-.98-1.016-1.506-1.486a8.262 8.262 0 00-1.447-1.254 1.727 1.727 0 00-1.587-.08c-.436.2-.84.462-1.2.78-.32.287-.605.6-.888.912-.158.174-.316.348-.478.515a38.294 38.294 0 00-1.647 1.84 33.63 33.63 0 00-1.533 1.96 7.26 7.26 0 00-.667 1.067c-.184.364-.35.738-.493 1.12-.074.146-.132.3-.174.46a.613.613 0 00.074.36c.142.148.326.25.526.293.667.2 2.26.573 2.927.667.156.03.317.03.473 0a.307.307 0 00.214-.24l.152-.226c.655-.967 2.332-3.445 3.181-4.44a2 2 0 01.193-.208.18.18 0 01.054.047c.335.376.648.77.94 1.18.63.833 1.35 1.86 1.886 2.626.396.565.693.988.78 1.087zm-7.8-.186v.053a.06.06 0 010-.053z"
          fill="#0D3727"
        />
      </g>
      <defs>
        <clipPath id="clip0_1021_7861">
          <path
            fill="#fff"
            transform="translate(.838 .912)"
            d="M0 0H16V16H0z"
          />
        </clipPath>
      </defs>
    </svg>
  )
}


function Cross(props) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0.32 0.27 7.06 8.73"
      {...props}
    >
      <path
        d="M1.568.273l2.25 3.63h.068l2.25-3.63h1.245L4.636 4.636 7.381 9H6.136l-2.25-3.563h-.068L1.568 9H.324l2.812-4.364L.324.273h1.244z"
        fill="#E6FFF1"
      />
    </svg>
  )
}


function TenSq(props) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 26 14"
      {...props}
    >
      <g clipPath="url(#clip0_1_7)" fill="#E6FFF1">
        <path d="M7.305 4.95v1.563H4.607v7.265H2.71V6.513H0V4.95h7.305z" />
        <path d="M10.43 7.382c.47.208.87.544 1.153.966.28.405.461.866.531 1.35.054.43.073.862.057 1.295H7.315c.027.655.26 1.115.697 1.378.29.17.624.255.961.245.398 0 .72-.1.969-.3a1.45 1.45 0 00.362-.448h1.78c-.049.387-.264.78-.647 1.18-.597.634-1.433.951-2.508.952a3.68 3.68 0 01-2.35-.804c-.68-.535-1.02-1.405-1.02-2.61 0-1.133.306-2 .919-2.602.612-.6 1.408-.903 2.387-.905a3.866 3.866 0 011.568.306M7.825 8.86c-.246.248-.401.585-.465 1.01h3.004c-.031-.453-.186-.797-.464-1.032a1.548 1.548 0 00-1.034-.354c-.447 0-.795.125-1.041.373M18.43 7.625c.438.353.656.94.655 1.757v4.396H17.3v-3.97c0-.344-.047-.608-.14-.791-.17-.336-.494-.504-.971-.503-.587 0-.99.246-1.208.736-.114.26-.171.59-.17.992v3.533h-1.745V7.261h1.688v.952c.224-.336.435-.577.634-.725.357-.264.81-.395 1.358-.395.687 0 1.249.177 1.685.53M19.355 0v6.505H26V0h-6.645zm5.043 4.937h-3.441v-3.37h3.441v3.37zM20.855 8.754a.369.369 0 00.08.213c.073.075.207.113.402.114a.623.623 0 00.274-.05.16.16 0 00.102-.15.162.162 0 00-.082-.146c-.055-.033-.258-.09-.608-.171-.253-.062-.43-.139-.534-.23a.49.49 0 01-.155-.391.668.668 0 01.242-.518c.162-.145.389-.217.682-.217.237-.01.473.046.679.162.175.11.275.297.301.563h-.578a.33.33 0 00-.063-.174c-.065-.077-.174-.116-.328-.116a.473.473 0 00-.27.058.165.165 0 00-.081.136.15.15 0 00.086.142c.057.03.26.083.607.158.192.034.371.117.52.241a.543.543 0 01.171.41.653.653 0 01-.246.527c-.166.14-.42.209-.764.209-.343 0-.602-.072-.775-.217a.694.694 0 01-.25-.552h.588zM23.972 7.348a.89.89 0 01.204.25v-.321h.56v3.034h-.576V9.178a.612.612 0 01-.222.235.793.793 0 01-.434.103.851.851 0 01-.656-.302c-.181-.2-.272-.47-.272-.805 0-.362.09-.652.272-.87a.845.845 0 01.672-.325c.16-.008.32.04.449.134m.124 1.429a.955.955 0 00.082-.42.889.889 0 00-.072-.354.441.441 0 00-.438-.284.433.433 0 00-.354.166c-.09.11-.134.28-.134.504a.949.949 0 00.061.37.421.421 0 00.425.274c.182.01.352-.09.427-.252" />
      </g>
      <defs>
        <clipPath id="clip0_1_7">
          <path fill="#fff" d="M0 0H26V14H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}


const BackToTop = () => {

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <button onClick={() => scrollToTop()} className='bg-[#E6FFF1] text-[#0D3727] tk-fatfrank font-bold rounded-[42px] h-[55px] px-[24px] flex flex-row items-center justify-center space-x-[12px]'>
      <span>Back to top</span> <Cheveron className='w-[16px] h-[16px]'/>
    </button>
  )
}
const Footer = () => {
  return (
    <>
      <div className="translate-y-[2px] text-[#0D3727]">
        <Grass />
      </div>
      <footer className="bg-[#0D3727] text-[#E6FFF1]">
        <div className="container-theme grid grid-cols-2 lg:grid-cols-5 lg:py-[60px] pt-[25px] pb-[85px]">
          <div className="col-span-2 lg:col-span-1 flex flex-row items-center justify-between">
            <img src={Logo} className="aspect-square w-[90px] lg:w-[183px] lg:h-[183px]" />
            <div className="lg:hidden">
              <BackToTop/>
            </div>
          </div>
          <div className="col-span-2 flex flex-col justify-between">
            <nav className="hidden lg:block">
              <ul className='text-[#E6FFF1] tk-fatfrank text-[16px] leading-[19px] flex flex-row space-x-[32px]'>
                {Links.map((link, index) => (
                  <li
                    key={index}
                    className=""
                  >
                    <a href={link.link}>{link.name}</a>
                  </li>
                ))}
              </ul>
            </nav>
            <p className="body-2  pt-[30px] lg:pt-0">
              A collection of the 6,000 most philoslothical creatures, living on
              the Ethereum Blockchain.
              <br />
              2022 Slow Mo Sloth Club (SMSC).   <br className="lg:hidden"/> All rights reserved.
            </p>
          </div>
          <div className="col-span-2 flex flex-col  justify-between items-center  pt-[35px] lg:pt-0">
                <ul className="hidden lg:block">
                <OpenSea/>

                </ul>

            <div className='space-y-[10px] text-center'>
            <p className="body-2">
            Website created by
            </p>
            <div className='flex flex-row space-x-[15px] items-end'>
              <Link to="https://uncommonstudio.com.au/">
            <UncommonLogo className='h-[20px]'/>
            </Link>
              <Cross className='h-[20px]'/>
              <Link to="https://tensq.com.au/">
              <TenSq className='h-[30px]'/>
              </Link>
            </div>
            </div>
          </div>
        </div>

      </footer>
    </>
  );
};

export default Footer;
